module.exports = __webpack_public_path__ + "img/after.13f23842.svg";